import React from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { isEqual, isUndefined, throttle, isFunction } from 'lodash';

import { Position } from 'types';
import { SurfaceNodePointsTo } from 'graphql/types';
import { usePrevious } from 'hooks';
import { notEqual } from 'utils';

// interface SelectedRiskkOperations {
//   setSelectedLink: (selectedLink?: SurfaceNodePointsTo) => void;
//   clearSelectedLink: () => void;
//   toggleLinkSelection: (link: SurfaceNodePointsTo) => void;
//   isLinkSelected: ({
//     link,
//     selectedLink,
//   }: {
//     link: SurfaceNodePointsTo;
//     selectedLink?: SurfaceNodePointsTo;
//   }) => boolean;
//   getIsLinkSelected(link: SurfaceNodePointsTo): boolean;
// }

type PositionFunction = (previousPosition: Position) => Position;

type SetRiskMenuPosition = (position?: Position | PositionFunction) => void;

// const selectedLinkVar = makeVar<SurfaceNodePointsTo | undefined>(undefined);
const riskMenuPositionVar = makeVar<Position | undefined>(undefined);

const setRiskMenuPosition = throttle(
  (position?: Position | PositionFunction): void => {
    console.log(' update position', position);
    if (isFunction(position)) {
      riskMenuPositionVar(position(riskMenuPositionVar() as Position));
    } else {
      riskMenuPositionVar(position);
    }
  },
  100,
);

function clearRiskMenuPosition(): void {
  if (riskMenuPositionVar()) {
    riskMenuPositionVar(undefined);
  }
}

// function setSelectedLink(selectedLink?: SurfaceNodePointsTo): void {
//   selectedLinkVar(selectedLink);
// }

// function clearSelectedLink(): void {
//   if (selectedLinkVar()) {
//     selectedLinkVar(undefined);
//   }
// }

// function toggleLinkSelection(link: SurfaceNodePointsTo) {
//   const selectedLink = selectedLinkVar();

//   if (selectedLink) {
//     return selectedLinkVar(undefined);
//   }

//   if (isUndefined(selectedLink)) {
//     return setSelectedLink(link);
//   }

//   setSelectedLink(link);
// }

// function isLinkSelected({
//   link,
//   selectedLink,
// }: {
//   link: SurfaceNodePointsTo;
//   selectedLink?: SurfaceNodePointsTo;
// }) {
//   const reverseLink = { ...link, from: link.to, to: link.from };
//   return isEqual(link, selectedLink) || isEqual(reverseLink, selectedLink);
// }

// function getIsLinkSelected(link: SurfaceNodePointsTo): boolean {
//   const selectedLink = selectedLinkVar();

//   const reverseLink = { ...link, from: link.to, to: link.from };
//   return isEqual(link, selectedLink) || isEqual(reverseLink, selectedLink);
// }

// const selectedLinkOperations = {
//   setSelectedLink,
//   clearSelectedLink,
//   toggleLinkSelection,
//   isLinkSelected,
//   getIsLinkSelected,
// };

// export function useSelectedLink(): [
//   SurfaceNodePointsTo | undefined,
//   SelectedLinkOperations,
// ] {
//   const state = useReactiveVar(selectedLinkVar);

//   return [state, selectedLinkOperations];
// }

// export function useLinkUnselectedListener(
//   link: SurfaceNodePointsTo,
//   callback: () => void,
// ) {
//   const selectedLink = useReactiveVar(selectedLinkVar);

//   const previousSelectedLink = usePrevious(selectedLink);

//   React.useEffect(() => {
//     if (isEqual(previousSelectedLink, link) && notEqual(link, selectedLink)) {
//       callback();
//     }
//   }, [selectedLink, previousSelectedLink, link]);
// }

// export function useSelectedLinkOperations(): SelectedLinkOperations {
//   return selectedLinkOperations;
// }

export function useRiskMenuPosition(): [
  Position | undefined,
  SetRiskMenuPosition,
] {
  const riskPosition = useReactiveVar(riskMenuPositionVar);

  return [riskPosition, setRiskMenuPosition];
}

export function useRiskMenuPositionOperation(): {
  setRiskMenuPosition: SetRiskMenuPosition;
  clearRiskMenuPosition: () => void;
} {
  return { setRiskMenuPosition, clearRiskMenuPosition };
}
